import { t } from '@lingui/macro'

import { FeatureFlagGuard } from '@/modules/shared/components/feature-flag-guard/FeatureFlagGuard'
import { isProduction } from '@/utils/environment'
import { ContactInformationPage } from './pages/contact-information/ContactInformation.page'
import { DebugSettingsPage } from './pages/debug-settings/DebugSettings.page'
import { ProfileHealthPage } from './pages/health/ProfileHealth.page'
import { ProfileMandatesPage } from './pages/mandaten/ProfileMandates.page'
import { ProfilePrivacyPage } from './pages/privacy/ProfilePrivacy.page'
import { AdditionalContactsPage } from './pages/profile-additional-contacts/AdditionalContacts.page'
import { ProfileRootPage } from './pages/profile-root'
import { ProfileSettingsPage } from './pages/settings/ProfileSettings.page'

import type { RouteObject } from 'react-router-dom'

const profileRoutes: RouteObject[] = [
  {
    path: 'profile',
    element: <ProfileRootPage />,
    children: [
      {
        path: 'information',
        element: (
          <ContactInformationPage
            title={t({
              id: 'profile.account-information.title',
              comment: 'Profile information',
              message: 'Persoonlijke gegevens',
            })}
            actionLabel={''}
          />
        ),
      },
      {
        path: 'additional-contacts',
        element: <AdditionalContactsPage />,
      },
      {
        path: 'health',
        element: <FeatureFlagGuard flag='health_parameters' />,
        children: [
          {
            index: true,
            element: <ProfileHealthPage />,
          },
        ],
      },
      {
        path: 'settings',
        element: <ProfileSettingsPage />,
      },
      {
        path: 'privacy',
        element: <ProfilePrivacyPage />,
      },
      {
        path: 'mandaten',
        element: <ProfileMandatesPage />,
      },
    ],
  },
]

if (!isProduction()) {
  profileRoutes[0].children!.push({
    path: 'debug-settings',
    element: <DebugSettingsPage />,
  })
}

export { profileRoutes }
